import { computed, ref } from "vue";

export function useCountdown({
  initialHours = 0,
  initialMinutes = 0,
  initialSeconds = 0,
  totalTime = 0,
  update,
  callback,
}: {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
  totalTime?: number;
  update?: (value: any) => void;
  callback?: () => void;
} = {}) {
  // 添加动画帧计数器逻辑
  const totalSeconds = ref(totalTime || initialHours * 3600 + initialMinutes * 60 + initialSeconds);
  const isRunning = ref(false);
  let lastTime = 0;
  let animationFrameId: any = null;
  const interval = 1000; // 1秒

  const formattedTime = computed(() => {
    const hours = Math.floor(totalSeconds.value / 3600);
    const minutes = Math.floor((totalSeconds.value % 3600) / 60);
    const seconds = totalSeconds.value % 60;
    return `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`;
  });

  function padZero(num: any) {
    return parseInt(num).toString().padStart(2, "0");
  }

  function updateCountdown(timestamp: any) {
    if (!isRunning.value) return;

    if (!lastTime) lastTime = timestamp;
    const elapsed = timestamp - lastTime;

    if (elapsed >= interval) {
      lastTime = timestamp - (elapsed % interval);

      if (totalSeconds.value <= 0) {
        stopCountdown();
        callback && callback();
        return;
      }

      totalSeconds.value--;
      update && update({ h: h.value, m: m.value, s: s.value });
    }

    animationFrameId = requestAnimationFrame(updateCountdown);
  }

  function startCountdown() {
    if (isRunning.value) return;
    isRunning.value = true;
    lastTime = 0;
    animationFrameId = requestAnimationFrame(updateCountdown);
  }

  let intervalId: any = null;
  function startRough() {
    if (isRunning.value) return;
    isRunning.value = true;
    intervalId = setInterval(() => {
      if (totalSeconds.value <= 0) {
        stopCountdown();
        callback?.();
        return;
      }
      totalSeconds.value--;
      update?.({ h: h.value, m: m.value, s: s.value });
    }, 1000);
  }

  function stopCountdown() {
    isRunning.value = false;
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }
  // onBeforeMount(() => {
  //   startCountdown();
  // });

  // onBeforeUnmount(() => {
  //   stopCountdown();
  // });

  const h = computed(() => padZero(totalSeconds.value / 3600));
  const m = computed(() => padZero((totalSeconds.value % 3600) / 60));
  const s = computed(() => padZero(totalSeconds.value % 60));

  return {
    startCountdown,
    startRough,
    stopCountdown,
    formattedTime,
    h,
    m,
    s,
  };
}
